import { Fragment } from 'react'
import {
	FooterNavHeading,
	FooterNavList,
	FooterNavListItemLink,
	FooterNavListWrapper,
} from './footerNavListParts'

export type Footer = { name: string; link?: string; data: FooterItem[] }

export type FooterItem =
	| FooterLinkItem
	| FooterItemLinkIconList
	| FooterCookieSettingsItem

type FooterLinkItem = {
	name: string
	link: string
	external: boolean
	type: 'nav'
}
type FooterItemLinkIconList = {
	iconList: FooterIcon[]
	type: 'iconList'
}
type FooterCookieSettingsItem = {
	name: string
	type: 'cookieSettings'
}

type FooterIcon = {
	href: string
	imageUrl: string
	alt: string
}

export default function FooterNavListSection({
	footerList,
}: {
	footerList: Footer
}) {
	return (
		<FooterNavListWrapper>
			{footerList.name !== 'Legal' && (
				<FooterNavHeading link={footerList.link}>
					{footerList.name}
				</FooterNavHeading>
			)}
			<FooterNavList>
				{footerList.data.map((item, index) => (
					<Fragment key={index}>
						{item.type === 'nav' && (
							<FooterNavListItemLink
								href={item.link}
								isExternal={item.external}
								isHeader={item.name === 'Legal'}
							>
								{item.name}
							</FooterNavListItemLink>
						)}
						<div></div>
						{item.type === 'cookieSettings' && (
							<li className="flex justify-start py-1 text-[10.5px] md:text-[9.6px] text-black ">
								<button
									className="hover:cursor-pointer w-fit text-start"
									type="button"
									onClick={() => {
										if (window.OneTrust) {
											window.OneTrust.ToggleInfoDisplay()
										}
									}}
								>
									{item.name}
								</button>
							</li>
						)}
						{item.type === 'iconList' && (
							<LogoList footerIcons={item.iconList} />
						)}
					</Fragment>
				))}
			</FooterNavList>
		</FooterNavListWrapper>
	)
}

function LogoList({ footerIcons }: { footerIcons: FooterIcon[] }) {
	return (
		<li className="flex gap-2">
			{footerIcons.map((footerIcon) => (
				<a
					className="block aspect-square h-6"
					href={footerIcon.href}
					target="_blank"
					rel="noreferrer"
					key={footerIcon.imageUrl}
				>
					<img
						className="h-full w-full"
						src={footerIcon.imageUrl}
						alt={footerIcon.alt}
					/>
				</a>
			))}
		</li>
	)
}
